// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td[data-v-e0ce5488],\nth[data-v-e0ce5488] {\n  vertical-align: middle;\n}\n.item2[data-v-e0ce5488] {\n  padding-top: 5px;\n}\n.item2[data-v-e0ce5488]:last-child {\n  border: 0 !important;\n}\n.item2[data-v-e0ce5488]:hover {\n  background: rgba(239, 239, 239, 0.28);\n}", ""]);
// Exports
module.exports = exports;
